import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { nacidRequests } from "api/nacidApi";
import { TextInput, required, useNotify, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import FormModal from "server/components/Modals/FormModal";
import { NacidFlowStepStatus } from "utils/constants";
import { Button } from "@mui/material";

// Bumping the step's revision is the ONLY way past the global idempotency index — the thing that makes a
// duplicate create impossible. It exists for divergence recovery alone: NACID no longer holds something we
// recorded as sent. NACID is authoritative, so that is never self-healed automatically.
const RedoStepDialog = ({ flowId, step }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  // A step still in flight has not finished telling us what happened; re-issuing it would race the attempt
  // already running. The backend answers 409, so do not offer the button at all.
  const isInFlight = step.status === NacidFlowStepStatus.InProgress || step.status === NacidFlowStepStatus.Pending;

  if (isInFlight) return null;

  const handleConfirm = async data => {
    await dataProvider.customRequest(nacidRequests.redoStep(flowId, step.id), { note: data.note }, "POST");

    notify("Стъпката е подадена повторно.", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      onConfirm={handleConfirm}
      titleContent="Повторно подаване на стъпката"
      saveTitle="Подай повторно"
      dialogSize="md"
      triggerButton={
        <Button
          label="Подай повторно"
          startIcon={<RestartAltIcon />}
          color="warning"
        />
      }
    >
      <TextInput
        source="note"
        label="Основание"
        validate={[required()]}
        multiline
        rows={3}
        fullWidth
        helperText={
          "Стъпката ще бъде изпратена към НАЦИД отново, въпреки че вече е била заявявана. Използвайте това " +
          "само когато НАЦИД вече не съдържа записа."
        }
      />
    </FormModal>
  );
};

export default RedoStepDialog;
